package ai.wagemix.web.screens

import kotlinx.coroutines.await
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.w3c.files.File
import kotlin.js.Promise

/** Reads a dropped file into memory so the data layer can upload it. */
suspend fun File.readBytes(): ByteArray {
    val buffer = (asDynamic().arrayBuffer() as Promise<ArrayBuffer>).await()
    return Int8Array(buffer).unsafeCast<ByteArray>()
}
